/* eb-geo.js (Tim 2026-06-18) — ONE shared geo lookup for the whole LP.
   Replaces the 3 separate ipapi.co calls (carousel + hero + footer) with a single
   cached, in-flight-deduped resolve. Load this EARLY + BLOCKING (no defer) so
   window.EBGeo exists before any inline section script runs.
   - EBGeo.get(cb): cb({cc,city,region,isUS}) once resolved. isUS may be null (unknown/failed).
     US is the graceful default everywhere (geo-fail => no intl swap => US copy stays).
   - EBGeo.swapIntl(): for confirmed non-US, text-node-swap US shipping/origin phrases
     -> worldwide / printed-to-order (used by the set LP; Enoch carousel keeps its own).
   - EBGeo.copyTier(): THE tier any page copy must use (see the 2026-08-07 note below).
   - EBGeo.cityFor(): the IP city, but ONLY when it agrees with copyTier(). */
(function(){
  if(window.EBGeo) return;
  var data=null, cbs=[], started=false;
  function emit(){ var d=data, q=cbs; cbs=[]; for(var i=0;i<q.length;i++){ try{q[i](d);}catch(e){} } try{ autoswap(); }catch(e){} }
  function store(d){
    data=d;
    /* 2026-08-07: persist only SUCCESSFUL resolves — caching a failure ({cc:''}) used to
       blank the city (and tier) for the visitor's entire session after one blocked call. */
    if(!d||!d.cc){ return; }
    try{ sessionStorage.setItem('eb_geo',JSON.stringify(d)); sessionStorage.setItem('eb_isus', d.isUS===true?'1':(d.isUS===false?'0':'')); }catch(e){}
  }
  function get(cb){
    if(typeof cb==='function') cbs.push(cb);
    /* PREVIEW OVERRIDE (Tim 2026-07-06): ?us=1 forces US so the US-gated membership can be previewed on the draft; ?us=0 forces non-US. Real visitors (no param) are unaffected. */
    try{ var _q=location.search||''; var _m=_q.match(/[?&]cc=([A-Za-z]{2})(?:&|$)/); if(_m){ var _c=_m[1].toUpperCase(); store({cc:_c,city:'',region:'',isUS:_c==='US',ovr:1}); } else if(/[?&]us=1(?:&|$)/.test(_q)){ store({cc:'US',city:'',region:'',isUS:true,ovr:1}); } else if(/[?&]us=0(?:&|$)/.test(_q)){ store({cc:'',city:'',region:'',isUS:false,ovr:1}); } }catch(e){}
    if(data!==null){ emit(); return; }
    try{ var c=sessionStorage.getItem('eb_geo'); if(c){ data=JSON.parse(c); emit(); return; } }catch(e){}
    if(started) return; started=true;
    function fin(cc,city,region){ store({ cc:cc||'', city:city||'', region:region||'', isUS: cc?(cc==='US'):null }); emit(); }
    function unknown(){ store({cc:'',city:'',region:'',isUS:null}); emit(); }
    /* 2026-08-07: city resolution was single-provider (ipapi.co — rate-limited + widely
       adblocked); its only fallback had NO city, so "Ships to <city>" silently degraded to
       "Ships —". Now a 4-step chain; the first three all return the city. */
    var PROV=[
      {u:'https://ipapi.co/json/',      p:function(g){ if(g&&g.country_code&&!g.error) return [g.country_code,g.city,g.region]; }},
      {u:'https://ipwho.is/',           p:function(g){ if(g&&g.success!==false&&g.country_code) return [g.country_code,g.city,g.region]; }},
      {u:'https://get.geojs.io/v1/ip/geo.json', p:function(g){ if(g&&g.country_code) return [g.country_code,g.city,g.region]; }},
      {u:'https://api.country.is/',     p:function(g){ if(g&&g.country) return [g.country,'','']; }}
    ];
    (function step(i){
      if(i>=PROV.length){ unknown(); return; }
      try{
        fetch(PROV[i].u).then(function(r){return r.json();}).then(function(g){
          var out=null; try{ out=PROV[i].p(g); }catch(e){}
          if(out){ fin(out[0],out[1],out[2]); } else { step(i+1); }
        }).catch(function(){ step(i+1); });
      }catch(e){ step(i+1); }
    })(0);
  }
  /* Country-tier copy engine (2026-07-10, pinned-pricing era): free shipping is
     now TRUE in US/GB/CA/AU/EU (fulfilled by the domestic BookVault plant or, in
     the EU, by Lulu France) — so claims localize instead of degrading to
     "worldwide". ROW keeps the old worldwide/tracked degrade. Geo-fail => US copy. */
  var EUSET={AT:1,BE:1,BG:1,HR:1,CY:1,CZ:1,DE:1,DK:1,EE:1,ES:1,FI:1,FR:1,GR:1,HU:1,IE:1,IT:1,LT:1,LU:1,LV:1,MT:1,NL:1,PL:1,PT:1,RO:1,SE:1,SI:1,SK:1,CH:1,NO:1,IS:1};
  function tierOf(cc){ if(!cc||cc==='US') return 'US'; if(cc==='GB') return 'GB'; if(cc==='CA') return 'CA'; if(cc==='AU') return 'AU'; if(EUSET[cc]) return 'EU'; return 'ROW'; }
  var TIER_TXT={
    GB:{ship:'UK',Ship:'UK',origin:'the UK'},
    CA:{ship:'Canadian',Ship:'Canadian',origin:'Canada'},
    AU:{ship:'Australian',Ship:'Australian',origin:'Australia'},
    EU:{ship:'EU',Ship:'EU',origin:'the EU'}
  };
  function swapsFor(t){
    if(t==='US') return [];
    if(t==='ROW') return [
      [' to order in the USA',' to order'],
      ['Ships free (U.S.), fully tracked','Ships worldwide · tracked'],
      ['ships free (U.S.), fully tracked','ships worldwide, fully tracked'],
      ['Ships free (U.S.)','Ships worldwide · tracked'],
      ['ships free (U.S.)','ships worldwide, tracked'],
      ['Free Worldwide Shipping','Ships Worldwide · Tracked'],
      ['Free worldwide tracked shipping','Worldwide tracked shipping'],
      ['Free U.S. Shipping','Ships Worldwide · Tracked'],
      ['Free US Shipping','Ships Worldwide · Tracked'],
      ['Free US shipping','Ships worldwide · tracked'],
      ['Free U.S. shipping','Ships worldwide · tracked'],
      ['free U.S. shipping','worldwide shipping'],
      ['free US shipping','worldwide shipping'],
      ['free worldwide shipping','worldwide shipping'],
      ['Printed & shipped in the USA','Printed to order · ships worldwide'],
      ['printed & shipped from the USA','printed to order, ships worldwide'],
      ['Printed in the USA','Printed to order'],
      ['printed in the USA','printed to order'],
      ['Ships from the U.S.','Ships worldwide, tracked'],
      /* 2026-08-16 (Tim): variants the swap missed — ALL-CAPS ticker chips, the bare
         value-stack row, the guarantee subline, and the long-form copyright-page quote
         (which contradicted the localized printed-in claims on non-US views). */
      ['FREE U.S. SHIPPING','SHIPS WORLDWIDE · TRACKED'],
      ['ships free in the U.S.','ships worldwide, tracked'],
      [', and "Printed in the United States of America" — inside',' — printed inside'],
      [', ISBN, and "Printed in the United States of America" are',' and ISBN are'],
      ['U.S. Shipping','Shipping']
    ];
    var x=TIER_TXT[t];
    var SV={GB:['£10','£20','£40'],CA:['$30','$60','$85'],AU:['$35','$70','$95'],EU:['€20','€42','€40']}[t];
    return [
      ['save $10','save '+SV[0]],['Save $10','Save '+SV[0]],
      ['save $22','save '+SV[1]],['Save $22','Save '+SV[1]],
      ['save $50','save '+SV[2]],['Save $50','Save '+SV[2]],['SAVE $50','SAVE '+SV[2]],
      [' to order in the USA',' to order in '+x.origin],
      ['Ships free (U.S.), fully tracked','Ships free ('+x.ship+'), fully tracked'],
      ['ships free (U.S.), fully tracked','ships free ('+x.ship+'), fully tracked'],
      ['Ships free (U.S.)','Ships free ('+x.ship+')'],
      ['ships free (U.S.)','ships free ('+x.ship+')'],
      ['Free U.S. Shipping','Free '+x.Ship+' Shipping'],
      ['Free US Shipping','Free '+x.Ship+' Shipping'],
      ['Free US shipping','Free '+x.ship+' shipping'],
      ['Free U.S. shipping','Free '+x.ship+' shipping'],
      ['free U.S. shipping','free '+x.ship+' shipping'],
      ['free US shipping','free '+x.ship+' shipping'],
      ['Printed & shipped in the USA','Printed & shipped in '+x.origin],
      ['printed & shipped from the USA','printed & shipped in '+x.origin],
      ['Printed in the USA','Printed in '+x.origin],
      ['printed in the USA','printed in '+x.origin],
      ['Ships from the U.S.','Ships from '+x.origin+', tracked'],
      /* 2026-08-16 (Tim): see the ROW note — caps chips, bare row, guarantee subline,
         and the copyright-page quote neutralized (never claim the page says something
         it may not for non-US-printed copies). */
      ['FREE U.S. SHIPPING',('FREE '+x.Ship+' SHIPPING').toUpperCase()],
      ['ships free in the U.S.','ships free in '+x.origin],
      [', and "Printed in the United States of America" — inside',' — printed inside'],
      [', ISBN, and "Printed in the United States of America" are',' and ISBN are'],
      ['U.S. Shipping',x.Ship+' Shipping']
    ];
  }
  function runSwaps(S){
    try{
      var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false),n;
      while(n=w.nextNode()){
        var pe=n.parentElement; if(!pe) continue; var tag=pe.tagName; if(tag==='SCRIPT'||tag==='STYLE'||tag==='NOSCRIPT') continue;
        var v=n.nodeValue; if(!v||v.length<5) continue; var nv=v;
        for(var i=0;i<S.length;i++){ if(nv.indexOf(S[i][0])>-1) nv=nv.split(S[i][0]).join(S[i][1]); }
        if(nv!==v) n.nodeValue=nv;
      }
    }catch(e){}
  }
  function marketTier(){ try{ var a=window.Shopify&&Shopify.currency&&Shopify.currency.active; return {EUR:'EU',GBP:'GB',CAD:'CA',AUD:'AU'}[a]||null; }catch(e){ return null; } }
  /* market-first (2026-07-24): the copy tier follows the CHARGED currency (same source as the
     prices), so page copy can never contradict pricing when IP geo fails or mis-resolves
     (VPN/Private Relay). IP cc only decides for USD (US vs International) and for the
     ?us=/?cc= preview overrides, which keep absolute precedence.

     copyTier() (2026-08-07) EXPORTS that precedence so every painter shares it. It exists
     because the geo-ship lines in 88book-footer / ethbible-extras / loa-social-proof were
     calling tierOf(IP cc) directly and so disagreed with this file's own swaps: on an
     AUD-charged page (Shopify.country=AU, price A$94.95) the announcement bar correctly
     read "Free Australian shipping · Printed in Australia" while the geo line read
     "Ships to Amsterdam — Free EU Shipping". Two shipping promises, one page. Never call
     tierOf(ipCc) for COPY — call copyTier(). tierOf() stays exported for genuine
     IP questions (e.g. delivery-day estimates keyed to the shipping origin). */
  function copyTier(){
    if(data && data.ovr) return tierOf(data.cc||'');
    return marketTier() || (data ? tierOf(data.cc||'') : null);
  }
  /* The IP city is only safe to print when it agrees with the tier we are charging in —
     "Ships to Amsterdam · Free Australian Shipping" is worse than no city at all. */
  function cityFor(){
    /* 2026-08-07 (Tim): ALWAYS show the real IP city when we know it — the earlier
       tier-agreement gate blanked "Ships to <city>" for any VPN/proxy session. The tier
       (shipping copy) still follows copyTier(), so price/copy stay coherent regardless. */
    try{ return (data && (data.city||data.region)) || ''; }catch(e){ return ''; }
  }
  /* MARKET AUTO-ALIGN (Tim 2026-08-07, all funnels): heal stale market cookies so prices,
     shipping copy, currency and the city line all match the visitor's REAL location.
     Guards: once per session; never on explicit ?country/?cc/?us overrides; only for a
     resolved 2-letter cc; only when it differs from the served localization country. */
  function autoAlign(){
    try{
      if(!data || !data.cc || data.ovr) return;
      if(/[?&](country|cc|us)=/.test(location.search||'')) return;
      if(sessionStorage.getItem('eb_market_aligned')==='1') return;
      var served=(window.Shopify&&Shopify.country)||'';
      var cc=String(data.cc||'').toUpperCase();
      if(!/^[A-Z]{2}$/.test(cc) || !served || served===cc) { sessionStorage.setItem('eb_market_aligned','1'); return; }
      sessionStorage.setItem('eb_market_aligned','1');
      var u=new URL(location.href); u.searchParams.set('country',cc);
      location.replace(u.toString());
    }catch(e){}
  }
  function autoswap(){ autoAlign(); var t=copyTier(); if(!t) return; var S=swapsFor(t); if(!S.length) return; if(document.body){ runSwaps(S); } else { document.addEventListener('DOMContentLoaded',function(){ runSwaps(S); }); } }
  function swapIntl(){ autoswap(); } /* legacy alias */
  window.EBGeo={ get:get, swapIntl:swapIntl, tierOf:tierOf, copyTier:copyTier, marketTier:marketTier, cityFor:cityFor };
  try{ if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){ try{autoswap();}catch(e){} }); } else { setTimeout(function(){ try{autoswap();}catch(e){} },0); } }catch(e){}
})();
